import React from 'react';
import { Tooltip } from '@mui/material';
import { Button } from 'system/atoms';
import { ADD_TO_JOB_ACTION_CANDIDATE_LIMIT } from 'modules/candidate-profile/constants';

type AddToJobActionButtonProps = {
  isOverCandidateLimit: boolean;
  onClick: () => void;
};

const getTooltipTitle = (isOverCandidateLimit: boolean): string =>
  isOverCandidateLimit
    ? `Select ${ADD_TO_JOB_ACTION_CANDIDATE_LIMIT} candidates or fewer to add to a job`
    : '';

/**
 * Hands the selection to the system the organisation has configured for its add-to-job,
 * in place of the ATS drawer. Past the candidate limit it is offered but withheld, so the
 * ceiling is visible rather than discovered by a selection silently losing its tail.
 */
export const AddToJobActionButton: React.FC<AddToJobActionButtonProps> = ({
  isOverCandidateLimit,
  onClick
}) => (
  <Tooltip title={getTooltipTitle(isOverCandidateLimit)}>
    {/* A disabled button fires no events of its own, so the tooltip needs a live wrapper. */}
    <span>
      <Button
        variant="primary"
        disabled={isOverCandidateLimit}
        onClick={onClick}
      >
        Add to job
      </Button>
    </span>
  </Tooltip>
);
